import React, { Component } from 'react';
// --- FIX: Locally defined Icon Components to resolve import error ---
// CheckCircleIcon component defined locally
const CheckCircleIcon = props => <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24" stroke="currentColor" {...props} data-id="element-138">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" data-id="element-139" />
  </svg>;
// Clock icon component defined locally
const Clock = props => <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props} data-id="element-140">
    <circle cx="12" cy="12" r="10" data-id="element-141" />
    <polyline points="12 6 12 12 16 14" data-id="element-142" />
  </svg>;
export const PricingSection = () => {
  return <div id="pricing" className="my-20 bg-gradient-to-br from-[#FDFCFB] to-[#E2EBF5] p-10 rounded-2xl shadow-xl" data-id="element-143">
      <h2 className="text-3xl font-bold mb-4 text-center text-[#0A1F44]" data-id="element-144">
        Limited-Time Launch Offer
      </h2>

      {/* --- SEASONAL CAMPAIGN BANNER --- */}
      <div className="flex justify-center mb-8" data-id="element-145">
        <div className="inline-flex items-center gap-3 bg-amber-100 text-amber-800 font-bold px-6 py-3 rounded-full border-2 border-amber-200" data-id="element-146">
          <Clock className="h-6 w-6" data-id="element-147" />
          <span data-id="element-148">Summer Flash Sale: Offer ends Sunday, July 13th</span>
        </div>
      </div>

      <div className="flex justify-center mb-10" data-id="element-149">
        <img src="https://cdn.shopify.com/s/files/1/0637/1675/3506/files/ChatGPT_Image_Jul_9_2025_01_27_25_PM.png?v=1752082052" alt="Clarity supplement product" className="w-full max-w-xl rounded-xl shadow-lg object-cover aspect-video" data-id="element-150" />
      </div>

      <p className="text-lg text-center max-w-3xl mx-auto text-gray-700 mb-8" data-id="element-151">
        Experience a clearer mind, sustained energy, and sharper focus. We're so
        confident you'll love Clarity, we're offering an exclusive introductory
        price—risk-free.
      </p>

      <div className="bg-white rounded-xl p-8 shadow-md mb-10" data-id="element-152">
        <h3 className="text-2xl font-bold mb-4 text-center text-[#0A1F44]" data-id="element-153">
          60-Day Risk-Free Guarantee
        </h3>
        <p className="text-center text-gray-700" data-id="element-154">
          If you don't feel noticeably more energized and focused within 60
          days, we'll issue a complete refund. Your satisfaction is our
          guarantee.
        </p>
      </div>

      <div className="max-w-xl mx-auto mb-8 text-gray-800" data-id="element-155">
        <h3 className="text-2xl font-bold mb-6 text-center text-[#0A1F44]" data-id="element-156">
          Your Exclusive Package Includes:
        </h3>
        <ul className="space-y-3" data-id="element-157">
          {['Premium Clarity Supplements (1 or 3 Bags)', 'Instant Savings: 25% off with Subscription', 'Free Priority Shipping (Limited Time)', '60-Day Full Satisfaction Guarantee'].map(item => <li className="flex items-center gap-2" key={item} data-id="element-158">
              <CheckCircleIcon className="text-[#E63946] h-6 w-6 flex-shrink-0" data-id="element-159" />{' '}
              {item}
            </li>)}
        </ul>
      </div>

      <h3 className="text-xl font-bold text-center text-[#0A1F44] mb-6" data-id="element-160">
        Select Your Package
      </h3>

      <div className="grid md:grid-cols-2 gap-10 max-w-4xl mx-auto" data-id="element-161">
        <div className="border rounded-xl p-8 flex flex-col bg-white shadow-md hover:shadow-xl transition duration-300" data-id="element-162">
          <h4 className="text-xl font-bold text-center text-[#0A1F44] mb-4" data-id="element-163">
            ONE-TIME PURCHASE
          </h4>
          <p className="text-lg text-center text-gray-700 mb-2" data-id="element-164">
            1-Month Supply
          </p>
          <p className="text-4xl font-bold text-center text-gray-900 mb-4" data-id="element-165">
            $79
          </p>
          <a href="https://claritysupplement.com/products/clarity-superfood-daily-gummies" className="mt-auto bg-[#0A1F44] hover:bg-opacity-90 text-white font-bold py-3 px-6 rounded-lg uppercase text-center transition duration-200" target="_blank" rel="noopener noreferrer" data-id="element-166">
            Buy Now
          </a>
        </div>
        <div className="border-2 border-[#E63946] rounded-xl p-8 flex flex-col bg-white shadow-xl relative transition duration-300 hover:scale-105" data-id="element-167">
          <span className="absolute -top-5 left-1/2 -translate-x-1/2 bg-[#E63946] text-white px-4 py-2 rounded-full font-bold text-sm shadow-md" data-id="element-168">
            BEST VALUE
          </span>
          <h4 className="text-xl font-bold text-center text-[#0A1F44] mb-4 mt-4" data-id="element-169">
            SUBSCRIBE & SAVE
          </h4>
          <p className="text-lg text-center text-gray-700 mb-1" data-id="element-170">
            1 Bag Per Month
          </p>
          <p className="line-through text-center text-gray-500" data-id="element-171">$79/month</p>
          <p className="text-4xl font-bold text-center text-[#E63946] mb-2" data-id="element-172">
            $59/month
          </p>
          <p className="text-center text-green-600 font-bold mb-4" data-id="element-173">
            Save 25% Instantly
          </p>
          <p className="text-sm text-gray-600 mb-4" data-id="element-174">
            Delivered every 30 days. Cancel, adjust, or pause anytime.
          </p>
          <a href="https://claritysupplement.com/products/clarity-superfood-daily-gummies" className="mt-auto bg-[#E63946] hover:bg-opacity-90 text-white font-bold py-3 px-6 rounded-lg uppercase text-center transition duration-200" target="_blank" rel="noopener noreferrer" data-id="element-175">
            Subscribe & Save
          </a>
        </div>
      </div>

      <p className="text-center text-sm text-gray-500 mt-10 mb-10" data-id="element-176">
        Secure checkout. Limited-time introductory offer applied automatically.
      </p>

      <div className="max-w-3xl mx-auto text-gray-800" data-id="element-177">
        <h3 className="text-2xl font-bold text-center text-[#0A1F44] mb-6" data-id="element-178">
          Transform Your Life Today
        </h3>
        <p className="text-center" data-id="element-179">
          You deserve to feel energized, clear-headed, and focused. Imagine
          waking up refreshed, ready to conquer your day. Make today the turning
          point. Your future self will thank you.
        </p>
      </div>

      <div className="mt-12" data-id="element-180">
        <img src="https://cdn.shopify.com/s/files/1/0637/1675/3506/files/ChatGPT_Image_Jul_9_2025_02_41_21_PM.png?v=1752086507" alt="Happy person enjoying life with newfound energy" className="w-full max-w-5xl mx-auto rounded-xl shadow-xl object-cover" data-id="element-181" />
      </div>
    </div>;
};